import React from "react";
import $ from "jquery";
import { msalAuth } from "../../../api/msal/MsalAuthProvider";
import ModalTreeChildren from "./modalTreeChildren";
import MyContext from "../../../api/context/my-context";
import * as Common from "../../common/common";
import * as omnimap from "../../../api/omnimap/omnimapActions";

class FolderManagement extends React.Component {
  constructor(props) {
    super(props);
    this.handleEvent = this.handleEvent.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addfolder = this.addfolder.bind(this);
    this.deletefolder = this.deletefolder.bind(this);

    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.state = {
      tabName: props.tabName,
      menuName: props.menuName,
      token: null,
      treeList: [],
      treeListUpdate: [],
      treekey: props.treekey,
      treeCount: 0,
      hiddenActive: true,
      hiddenActiveAlert: false,
      folderName: "",
      deleteCheck: false,
    };
  }
  handleEvent() {
    var tree = this.state.treeList;
    this.state = {
      tabName: this.props.tabName,
      menuName: this.props.menuName,
      token: this.state.token,
      treeList: tree,
      treeListUpdate: this.state.treeListUpdate,
      treekey: this.props.treekey,
      folderName: this.state.folderName,
      hiddenActive: this.state.hiddenActive,
      hiddenActiveAlert: this.state.hiddenActiveAlert,
      deleteCheck: this.state.deleteCheck,
    };
  }
  handleChange(event) {
    this.setState({ folderName: event.target.value });
  }
  handleToggle = () => {
    var that = this;

    //open olan dalın altında ul varsa silme

    var element = document.getElementsByClassName("open");

    var children = Array.from(element[element.length - 1].children);
    var childrenresult;
    children.forEach((item) => {
      if (item.localName === "ul") {
        childrenresult = true;
      } else childrenresult = false;
    });

    if (childrenresult) {
      this.setState({
        hiddenActive: !this.state.hiddenActive,
        hiddenActiveAlert: !this.state.hiddenActiveAlert,
      });
    } else {
      var parent = document.getElementsByClassName("open");
      if (parent.length > 0) {
        var parentFolderName = "";
        var parent = document.getElementsByClassName("open");
        if (parent.length > 0) {
          parentFolderName = parent[parent.length - 1].textContent;
        }
        if (that.state.hiddenActive) {
          this.setState({
            hiddenActive: !this.state.hiddenActive,
            folderName: parentFolderName,
          });
        }
      }
    }
  };
  handleToggleClose = () => {
    this.setState({
      hiddenActive: !this.state.hiddenActive,
      hiddenActiveAlert: false,
      folderName: "",
    });
  };

  list = [];
  allTree = {
    treeList: [],
    treecount: null,
  };
  model = {
    content: [
      {
        key: "algemeen-isvoor",
        and_or: "AND",
        values: [this.props.treekey],
        datatype: "STRING",
      },
    ],
    context: [],
    timestamps: [],
    definitions: [process.env.REACT_APP_TREE],
    statuses: [],
  };

  GetTreeStructure(model, isUpdate) {
    var that = this;

    Common.GetTreeStructure("", model, that.state.token, isUpdate).then(
      function (TreeResult) {
        if (!isUpdate) {
          // var result = list_to_tree(list, 0);
          if (TreeResult != undefined) {
            that.setState({ treeList: [] });
            that.setState({
              treeList: TreeResult.treeList.sort(function (a, b) {
                if (a.name.toLowerCase() < b.name.toLowerCase()) {
                  return -1;
                }
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                  return 1;
                }
                return 0;
              }),
            });
          } else {
            that.setState({ treeList: [] });
          }
        } else {
          that.allTree.treeList = TreeResult.treeList;
          that.allTree.treecount = TreeResult.treecount;
        }
      }
    );
  }

  /*** EKRANIN HERHANGİ BİRYERİNE TIKLANINCA POPUP KALDIRMA İÇİN KULLANILAN FONKSİYON ***/
  handleClickOutside(event) {
    var that = this;
    if (that.state.hiddenActive) {
      if (
        document.getElementById("mappen_beheren_modal") &&
        document.getElementById("mappen_beheren_modal").className !=
          "modal fade" &&
        event.target.id != "map_x" &&
        event.target.className != "addfolder" &&
        event.target.className != "close" &&
        event.target.className != "modal fade show" &&
        event.target.className != "button delete"
      ) {
        if (
          this.wrapperRef &&
          this.wrapperRef.current &&
          !this.wrapperRef.current.contains(event.target)
        ) {
          document.getElementById("tree-parent-id").setAttribute("value", "");
          var tree = document.querySelectorAll(".map_menu");
          var opensubs = tree[0].querySelectorAll(":scope .open");

          if (opensubs.length !== 0) {
            for (var i = 0; i < opensubs.length; i++) {
              opensubs[i].classList.remove("open");
              opensubs[i].children[0].classList.remove("active");
            }
          }

          $("#side-menu-outside-false").click();
        }
      }
    }
  }

  addfolder() {
    var that = this;
    if (that.state.folderName) {
      var d = document;
      var parentFolder = null;
      var parent = document.getElementsByClassName("open");
      if (parent.length > 0) {
        parentFolder = parent[parent.length - 1].getAttribute("id");
      }
      var model =
        parentFolder != null
          ? {
              relationships: { definition: { code: "FOLDER" } },
              name: that.state.folderName,
              content: {
                algemeen: {
                  issubfolder: true,
                  actief: true,
                  isvoor:
                    that.state.treekey.toString().charAt(0).toUpperCase() +
                    that.state.treekey.toString().slice(1),
                  parentfolder: parentFolder,
                },
              },
            }
          : {
              relationships: { definition: { code: "FOLDER" } },
              name: that.state.folderName,
              content: {
                algemeen: {
                  issubfolder: false,
                  actief: true,
                  isvoor:
                    that.state.treekey.toString().charAt(0).toUpperCase() +
                    that.state.treekey.toString().slice(1),
                },
              },
            };

      omnimap
        .AddFolderAction(model, window.$catalog_management_units_token)
        .then((data) => {
          if ((data.result.status = "OK")) {
            that.setState({ deleteCheck: true });
            $("#cover-spin").show(0);

            that.setState({ folderName: "" });
            Common.sleep(1100).then(() => {
              Common.GetTreeStructure(
                "",
                that.model,
                that.state.token,
                true
              ).then(function (TreeResult) {
                if (TreeResult) {
                  Common.sleep(900).then(() => {
                    that.allTree.treeList = TreeResult.treeList;
                    that.allTree.treecount = TreeResult.treecount;
                    that.setState({ folderName: "" });
                    $("#treeButton").click();
                    $("#cover-spin").hide(0);
                  });
                }
              });
            });
          }
        });
    } else alert("schrijf mapnaam");
  }
  deletefolder() {
    var that = this;

    var folderId = "";
    var parent = document.getElementsByClassName("open");
    if (parent.length > 0) {
      folderId = parent[parent.length - 1].getAttribute("id");
    }

    omnimap
      .DeleteFolderAction([], folderId, window.$catalog_management_units_token)
      .then((result) => {
        $("#cover-spin").show(0);

        document.getElementById("button-delete").classList =
          "button delete disabled";
        that.setState({ deleteCheck: false });

        document.getElementById("tree-parent-id").setAttribute("value", "");
        var tree = document.querySelectorAll(".map_menu");
        var opensubs = tree[0].querySelectorAll(":scope .open");

        if (opensubs.length !== 0) {
          for (var i = 0; i < opensubs.length; i++) {
            opensubs[i].classList.remove("open");
            opensubs[i].children[0].classList.remove("active");
          }
        }

        that.handleToggleClose();
        that.setState({ folderName: "" });

        Common.sleep(900).then(() => {
          Common.GetTreeStructure("", that.model, that.state.token, true).then(
            function (TreeResult) {
              if (TreeResult) {
                that.allTree.treeList = TreeResult.treeList;
                that.allTree.treecount = TreeResult.treecount;
                that.setState({ folderName: "" });
                $("#treeButton").click();
                $("#cover-spin").hide(0);
              }
            }
          )
        });
      });
  }

  /*** React Life Cicyle Functions ***/
  componentDidUpdate(prevProps, prevState) {
    var that = this;
    if (prevProps.treekey != that.state.treekey) {
      that.model.content[0].values[0] = that.state.treekey;

      that.GetTreeStructure(that.model);
    }
  }

  async componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);

    var that = this;
    try {
      const accessTokenRequest = {
        scopes: ["user.read", "openid", "profile"],
      };
      var accessToken = null;
      try {
        accessToken = await msalAuth
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            // token = response.idToken.rawIdToken;
            that.setState({ token: response.idToken.rawIdToken });
          });
      } catch (error) {
        console.log("AquireTokenSilent failure");
        console.log(error);
        accessToken = await msalAuth
          .acquireTokenPopup(accessTokenRequest)
          .then((response) => {
            // get access token from response
            // response.accessToken
            // token = response.idToken.rawIdToken;
            that.setState({ token: response.idToken.rawIdToken });
          })
          .catch((err) => {
            // handle error
            console.log(err);
          });
      }
    } catch (err) {
      var error = {};
      if (typeof err === "string") {
        var errParts = err.split("|");
        error =
          errParts.length > 1
            ? { message: errParts[1], debug: errParts[0] }
            : { message: err };
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        };
      }

      this.setState({
        user: {},
        isLoading: false,
        error: error,
        treeList: null,
      });
    }

    that.GetTreeStructure(that.model);

    var mappen_beheren = document.querySelector("#mappen_beheren");
    if (mappen_beheren) {
      document
        .querySelector("#mappen_beheren")
        .addEventListener("click", function (e) {
          $("#mappen_beheren_modal").modal("show");

          document.getElementById("tree-parent-id").setAttribute("value", "");
          var tree = document.querySelectorAll(".map_menu");
          var opensubs = tree[0].querySelectorAll(":scope .open");

          if (opensubs.length !== 0) {
            for (var i = 0; i < opensubs.length; i++) {
              opensubs[i].classList.remove("open");
              opensubs[i].children[0].classList.remove("active");
            }
          }
        });
    }
  }
  render() {
    this.handleEvent();

    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="mappen_beheren_modal"
      >
        <MyContext.Consumer>
          {(context) => (
            <div hidden>
              <button
                id="treeButton"
                onClick={() => {
                  context.actions.addTask(this.allTree);
                  context.actions.treeClickButton(this.state.deleteCheck);
                }}
              >
                + add
              </button>
            </div>
          )}
        </MyContext.Consumer>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                hidden={this.state.hiddenActive ? false : true}
              >
                <div>
                  <span className="blacktext">Mappen </span>
                  <span className="greentext">
                    beheren
                    {/* {this.state.treekey
                      ? this.state.treekey.toString().charAt(0).toUpperCase() +
                        this.state.treekey.toString().slice(1)
                      : ""} */}
                  </span>
                </div>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div
                id="tree-side"
                hidden={this.state.hiddenActive ? false : true}
              >
                <div className="fullwidth">
                  <input
                    id="map_x"
                    type="input"
                    className="form-control new folder"
                    placeholder="Naam van de map..."
                    autocomplete="off"
                    value={this.state.folderName}
                    onChange={this.handleChange}
                  />
                  <a
                    href="javascript:void(0)"
                    className="addfolder"
                    onClick={this.addfolder}
                  />
                </div>
                <div ref={this.wrapperRef}>
                  <MyContext.Consumer>
                    {(context) => (
                      <div>
                        <ModalTreeChildren
                          TreeList={
                            context.store.treeCount == null
                              ? this.state.treeList
                              : context.store.treeCount != this.state.treeCount
                              ? context.store.treeList
                              : this.state.treeList
                          }
                        />
                      </div>
                    )}
                  </MyContext.Consumer>
                </div>
              </div>
              <div
                id="delete-side"
                hidden={this.state.hiddenActive ? true : false}
              >
                <div id="delete-side-img"></div>

                {this.state.hiddenActiveAlert ? (
                  <div>
                    {" "}
                    <div className="delete-side-div">
                      <span className="delete-side-text">
                        Omdat er mappen aan deze map zijn gekoppeld, kunt u deze
                        niet verwijderen
                      </span>
                    </div>
                    <div className="delete-side">
                      <div className="delete-side-cancel">
                        <a
                          className="button back"
                          onClick={this.handleToggleClose}
                        >
                          Annuleren
                        </a>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    {" "}
                    <div className="delete-side-div">
                      <span className="delete-side-text">
                        Weet u zeker dat u map
                        <span id="delete-folder-name">
                          {" "}
                          “{this.state.folderName}”{" "}
                        </span>
                        wilt verwijderen?
                      </span>
                    </div>
                    <div className="delete-side">
                      <div className="delete-side-cancel">
                        <a
                          className="button back"
                          onClick={this.handleToggleClose}
                        >
                          Annuleren
                        </a>
                      </div>
                      <div className="delete-side-ok">
                        <a
                          className="button delete"
                          onClick={this.deletefolder}
                        >
                          Verwijder{"\u00A0"}map
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              className="modal-footer"
              hidden={this.state.hiddenActive ? false : true}
            >
              <MyContext.Consumer>
                {(context) => (
                  <a
                    id="button-delete"
                    className={
                      context.storeToggle.treeClickChange
                        ? "button delete"
                        : "button delete disabled"
                    }
                    onClick={this.handleToggle}
                  >
                    Verwijder map
                  </a>
                )}
              </MyContext.Consumer>
              <MyContext.Consumer>
                {(context) => (
                  <div hidden>
                    <button
                      id="side-menu-outside-false"
                      onClick={() => context.actions.treeClickButton(false)}
                    ></button>
                    <button
                      id="side-menu-outside-true"
                      onClick={() => context.actions.treeClickButton(true)}
                    ></button>
                  </div>
                )}
              </MyContext.Consumer>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FolderManagement;
